var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0002 3.5C15.2378 3.5 16.4248 3.99167 17.3 4.86683C18.1752 5.742 18.6668 6.92899 18.6668 8.16667C18.6668 9.01833 18.4452 9.81167 18.0368 10.5H21.0002C22.1085 10.5 23.0418 11.2817 23.2752 12.32C25.6202 21.665 25.6668 21.91 25.6668 22.1667C25.6668 22.7855 25.421 23.379 24.9834 23.8166C24.5458 24.2542 23.9523 24.5 23.3335 24.5H4.66683C4.04799 24.5 3.4545 24.2542 3.01691 23.8166C2.57933 23.379 2.3335 22.7855 2.3335 22.1667C2.3335 21.91 2.38016 21.665 4.72516 12.32C4.9585 11.2817 5.89183 10.5 7.00016 10.5H9.9635C9.54699 9.79324 9.32931 8.98702 9.3335 8.16667C9.3335 6.92899 9.82516 5.742 10.7003 4.86683C11.5755 3.99167 12.7625 3.5 14.0002 3.5ZM14.0002 5.83333C13.3813 5.83333 12.7878 6.07917 12.3502 6.51675C11.9127 6.95434 11.6668 7.54783 11.6668 8.16667C11.6668 8.7855 11.9127 9.379 12.3502 9.81658C12.7878 10.2542 13.3813 10.5 14.0002 10.5C14.619 10.5 15.2125 10.2542 15.6501 9.81658C16.0877 9.379 16.3335 8.7855 16.3335 8.16667C16.3335 7.54783 16.0877 6.95434 15.6501 6.51675C15.2125 6.07917 14.619 5.83333 14.0002 5.83333Z",
    fill: "#4B508D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalIcon);
export default __webpack_public_path__ + "static/media/total_icon.803b2d3967e3129424e65f7b135d4c16.svg";
export { ForwardRef as ReactComponent };